import { observer } from 'mobx-react';
import React, { RefObject } from 'react';
import { DependencyContainer } from '../../utils/DependencyInjection';
import { DataTableFilterService } from '../../services/DataTableFilterService';
import { MonitoringRestService } from '../../services/MonitoringRestService';
import { UndeliveredKibanaSummaryByTujuanContainer } from './UndeliveredKibanaSummaryByTujuanContainer';
import { UndeliveredKibanaSummaryByLastStatusContainer } from './UndeliveredKibanaSummaryByLastStatusContainer';
import { Fieldset } from 'primereact/fieldset';
import { UndeliveredKibanaSummaryByLastTrackingSiteContainer } from './UndeliveredKibanaSummaryByLastTrackingSiteContainer';
import { DateHelper } from '../../utils/DateHelper';
import Loader from 'react-loader-spinner'

@observer
export class MonitoringLineHaulSummaryContainer extends React.Component<any, any> {
  dataTableFilterService = DependencyContainer.get(DataTableFilterService);
  monitoringRestService = DependencyContainer.get(MonitoringRestService);

  filterParams;
  refTujuan: RefObject<UndeliveredKibanaSummaryByTujuanContainer> = React.createRef();
  refLastTrackingSite: RefObject<UndeliveredKibanaSummaryByLastTrackingSiteContainer> = React.createRef();
  refLastStatus: RefObject<UndeliveredKibanaSummaryByLastStatusContainer> = React.createRef();
  data: never[];

  constructor(props, context) {
    super(props, context);
    this.state = {
      tujuanCollapsed: false,
      partnerCollapsed: false,
      lastTrackingSiteCollapsed: false,
      lastStatusCollapsed: false,
      loadUndeliveredData:false,
      lhd: '',
      lhu: '',
      dmp:'',
    };
  }

  componentDidMount() {
    // this.dataSource.onPageChange.subscribe(() => {
    //   this.loadData();
    // });
  }
  // public async loadDatas(filterParams) {
  //   console.log('aaa')
  //   this.data = [];
  //   this.filterParams = filterParams;
  //   const fParams = Object.assign({}, filterParams);
  //   this.setState({ loadUndeliveredData: 'load' });

  //   if (fParams.startDate) fParams.startDate = DateHelper.formatLocalDateForQueryParam(fParams.startDate);
  //   if (fParams.endDate) fParams.endDate = DateHelper.formatLocalDateForQueryParam(fParams.endDate);

  //   this.monitoringRestService
  //     .post(`monitoring-tracking-linehaul?date=${fParams.startDate}`, fParams)
  //     .subscribe(
  //       response => {
  //         console.log(response)
  //         this.data = response;
  //       },
  //       () => {
  //         this.setState({ loadUndeliveredData: false });
  //       },
  //       () => {
  //         this.setState({ loadUndeliveredData: true });
  //       },
  //     );
  // }

  loadData(filterParams: any) {
    this.filterParams = filterParams;
    // this.refTujuan.current!.loadData(this.filterParams);
    // this.refLastTrackingSite.current!.loadData(this.filterParams);
    // this.refLastStatus.current!.loadData(this.filterParams);

    this.data = [];
    this.filterParams = filterParams;
    const fParams = Object.assign({}, filterParams);
    this.setState({ loadUndeliveredData: true,lhd: '',
      lhu: '',
      dmp: '', });

    if (fParams.startDate) fParams.startDate = DateHelper.formatLocalDateForQueryParam(fParams.startDate);
    if (fParams.endDate) fParams.endDate = DateHelper.formatLocalDateForQueryParam(fParams.endDate);

    this.monitoringRestService
      .get(`monitoring-tracking-linehaul?date=${fParams.startDate}`)
      .subscribe(
        response => {
          this.setState({
            lhd: response.lhd,
            lhu: response.lhu,
            dmp: response.dmp,
          })
          this.data = response;
          this.setState({ loadUndeliveredData: false });
        },
        () => {
          this.setState({ loadUndeliveredData: false });
        },
        () => {
          this.setState({ loadUndeliveredData: true });
        },
      );
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-3">
            <Fieldset legend="Line Haul Darat" toggleable={true} collapsed={this.state.tujuanCollapsed} onToggle={(e) => this.setState({ tujuanCollapsed: e.value })}>
              {this.state.lhd ? <UndeliveredKibanaSummaryByTujuanContainer ref={this.refTujuan} lhd={this.state.lhd} filters={this.filterParams} />:this.state.loadUndeliveredData? (
                    <Loader
                      type="ThreeDots"
                      color="#c8c8c8"
                      height="50"
                      width="50"
                    />
                  ):'Tidak Ada Data'} 
            </Fieldset>
          </div>

          <div className="col-md-3">
            <Fieldset legend="Line Haul Udara" toggleable={true} collapsed={this.state.lastTrackingSiteCollapsed} onToggle={(e) => this.setState({ lastTrackingSiteCollapsed: e.value })}>
            {this.state.lhu ? <UndeliveredKibanaSummaryByLastTrackingSiteContainer ref={this.refLastTrackingSite} lhu={this.state.lhu} filters={this.filterParams} />:this.state.loadUndeliveredData? (
                    <Loader
                      type="ThreeDots"
                      color="#c8c8c8"
                      height="50"
                      width="50"
                    />
                  ):'Tidak Ada Data'}
            </Fieldset>
          </div>

          <div className="col-md-3">
            <Fieldset legend="Darat MP" toggleable={true} collapsed={this.state.lastStatusCollapsed} onToggle={(e) => this.setState({ lastStatusCollapsed: e.value })}>
              {this.state.lhu ? <UndeliveredKibanaSummaryByLastStatusContainer ref={this.refLastStatus} dmp={this.state.dmp} filters={this.filterParams} /> : this.state.loadUndeliveredData? (
                    <Loader
                      type="ThreeDots"
                      color="#c8c8c8"
                      height="50"
                      width="50"
                    />
                  ):'Tidak Ada Data'}
            </Fieldset>
          </div>

          {/* <div className="col-md-3">
            <Fieldset legend="Partner" toggleable={true} collapsed={this.state.partnerCollapsed} onToggle={(e) => this.setState({ partnerCollapsed: e.value })}>
              <UndeliveredKibanaSummaryByPartnerContainer ref={this.refPartner} />
            </Fieldset>
          </div> */}
        </div>
      </div>
    );
  }
}
